import { AccessPermissions } from '@circlefin/permissions'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Access to view the legacy approval workflow.
 */
export const LEGACY_APPROVAL_WORKFLOW_MUTATION: PermissionSet = {
  access: AccessPermissions.protected,
  excludeAny: [SynthRole.SYNTH_NEW_APPROVAL_WORKFLOW_ONE],
}
